let policy;
// istanbul ignore next
// oxlint-disable-next-line typescript/no-explicit-any
if (typeof (globalThis as any).trustedTypes !== 'undefined') {
  // oxlint-disable-next-line typescript/no-explicit-any
  policy = (globalThis as any).trustedTypes.createPolicy('dangerouslySetInnerHTMLPolicy', {
    createHTML: (string: string) => string,
  });
}

const fallbackPolicy = {
  createHTML: (string: string) => string,
};

/**
 * THIS IS DANGEROUS.
 *
 * Setting innerHTML without properly sanitizing it can lead to XSS security vulnerabilities.
 * Only use this policy if you know for certain the string is safe to use.
 */
export const dangerouslySetInnerHTMLPolicy: { readonly createHTML: (string: string) => string } =
  policy || fallbackPolicy;
